import React from 'react';
import Text from './text';


export default (obj) => {
    return <Text multiline={true} rows={5} {...obj} />
}


// WEBPACK FOOTER //
// ./src/uis/form/textarea.js